(function () {
  class AnimatedWindowPanel extends PIXI.Container {
    constructor() {
      super();
      const self = this;
      this._completeCallback;
      StateMachine.Create(this);
    }

    initialise() {
      this._spotlight0 = undefined;
      this._spotlight1 = undefined;
      this._spotlightRotationAnim0 = undefined;
      this._spotlightRotationAnim1 = undefined;

      const self = this;
      messageBus.subscribe("spinner:GameConfigEvent", function () {
        self.onLayoutComplete();
      });
    }

    play() {
      this.visible = true;

      this._panelSparkleEmitter.particleEmitter.emit = true;
      this._panelSparkleEmitter.visible = true;

      this._spotlightRotationAnim0.play();
      this._spotlightRotationAnim1.play();
    }

    stop() {
      this.visible = false;

      this._panelSparkleEmitter.particleEmitter.emit = false;
      this._panelSparkleEmitter.visible = false;

      this._spotlightRotationAnim0.pause();
      this._spotlightRotationAnim1.pause();
    }

    onLayoutComplete() {
      this._spotlight0 = resourceManager.get(this.name + ":gambleIntroAnimatedPanelContainer:spotlight0");
      this._spotlight0.rotation = 0;
      this._spotlight0.blendMode = PIXI.BLEND_MODES.ADD;

      this._spotlightRotationAnim0 = gsap.to(this._spotlight0, {
        paused: true,
        duration: 10,
        rotation: Math.PI,
        repeat: -1,
        ease: "none",
      });

      this._spotlight1 = resourceManager.get(this.name + ":gambleIntroAnimatedPanelContainer:spotlight1");
      this._spotlight1.rotation = 0;
      this._spotlight1.blendMode = PIXI.BLEND_MODES.ADD;
      this._spotlightRotationAnim1 = gsap.to(this._spotlight1, {
        paused: true,
        duration: 10,
        rotation: -Math.PI,
        repeat: -1,
        ease: "none",
      });

      this._panelSparkleEmitter = particleManager.createEmitter(
        "panelSparkleEmitter",
        this.name + ":gambleIntroAnimatedPanelContainer:particlesContainer",
        0,
        0,
        false
      );
      this._panelSparkleEmitter.blendMode = PIXI.BLEND_MODES.ADD;
      this._panelSparkleEmitter.particleEmitter.emit = false;
      this._panelSparkleEmitter.visible = false;

      this.visible = false;
    }
  }

  create = function (json) {
    return new AnimatedWindowPanel();
  };

  getFilesRequired = function (json) {
    return [];
  };

  resourceManager.registerObjectType("animatedWindowPanel", create, initialise, getFilesRequired);
})();
